import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./whatsapp.css";

export default function WhatsAppFloating() {
  const phoneNumber = "971545832317"; 
  const message =
    "Hi, I need help with something. Could you please assist me?";

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="whatsappWrapper">
      <a
        href={whatsappURL}
        className="whatsappFloat"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <div className="whatsappTooltip">
        If you need help with anything, feel free to contact us.
      </div>
    </div>
  );
}